import { defineMessages } from 'react-intl';

export default defineMessages({
    /**
     * Messages used in the *.metadata.json5
     */
    incorrectLossEstimatate: {
        id: 'fnol.common.sasria-contract-works-incident.incorrectLossEstimatateId',
        defaultMessage: 'Missing required field "Loss Estimate"'
    },
    incorrectLossEstimatateMessage: {
        id: 'nol.common.sasria-contract-works-incident.incorrectLossEstimatateMessage.',
        defaultMessage: 'Loss Estimate is an Amount field and cannot accept alphanumeric values'
    },

    fnolLossEstimateErrorTitle: {
        id: 'fnol.common.views.fnol.cw.Loss Estimate validation failed',
        defaultMessage: 'Loss Estimate validation failed'
    },

    fnolLossEstimateErrorMessage: {
        id: 'fnol.common.views.fnol.cw.Value of Loss Estimate cannot be less than R1.0',
        defaultMessage: 'Value of Loss Estimate cannot be less than R1.0'
    },

    fnolLossEstimateErrorMessageLessThan16: {
        id: 'fnol.common.views.fnol.cw.can have no more than 16 digit to left of decimal point',
        defaultMessage: 'Loss Estimate : can have no more than 16 digit to left of decimal point'
    },

    fnolInceptionDateRequired: {
        id: 'fnol.common.views.fnolInceptionDateRequired',
        defaultMessage: 'Missing required field "Inception Date"'
    },
    fnolDurationMonths: {
        id: 'fnol.common.views.fnolDurationMonths',
        defaultMessage: 'Missing required field "Duration Months"'
    },
    contractNumberReq: {
        id: 'fnol.common.views.contractNumberReq',
        defaultMessage: 'Missing required field "Contract Number"'
    },
    contractValueReq: {
        id: 'fnol.common.views.contractValueReq',
        defaultMessage: 'Missing required field "Contract Value"'
    },
    contractLimitReq: {
        id: 'fnol.common.views.contractLimitReq',
        defaultMessage: 'Missing required field "Contract Limit"'
    },
    haveLossEstimateMessage: {
        id: 'fnol.bi.sasria-contract-works.haveLossEstimateMessage',
        defaultMessage: 'Missing required field "Do you have a Loss Estimate?"'
    },
    noIncidentAddedTitle: {
        id: 'fnol.common.contract.sasria-vehicle-incident.noIncidentAddedTitle',
        defaultMessage: 'Error'
    },
    noIncidentAddedMessage: {
        id: 'fnol.common.contract.sasria-vehicle-incident.noIncidentAddedMessage.',
        defaultMessage: 'Please add incident/incidents before clicking on Next'
    },
    passportNoValidationTitle: {
        id: 'fnol.common.policy-cw.passportNoValidationTitle',
        defaultMessage: 'Passport Number validation has failed'
    },
    passportNoValidationMessage: {
        id: 'nol.common.policy-cw.passportNoValidationMessage.',
        defaultMessage: 'Passport Number must be less than 13 digits and aplha numeric with no spaces.'
    },
    idNoValidationTitle: {
        id: 'fnol.common.policy-cw.idNoValidationTitle',
        defaultMessage: 'Identity Number validation has failed'
    },
    idNoValidationMessage: {
        id: 'nol.common.policy-cw.idNoValidationMessage.',
        defaultMessage: 'Identity Number must be 13 digit numeric number with no spaces(YYMMDDNNNNNNN).It is a mandatory field.'
    },
    addressRequiredTitle: {
        id: 'fnol.common.policy-cw.AddressReqTitle.',
        defaultMessage: 'Error - Address is required field'
    },
    addressRequiredMessage: {
        id: 'fnol.common.policy-cw.AddressReqMessage.',
        defaultMessage: 'An address with a city must be selected in order to proceed'
    },

});
